const indexItems = [
  { icon: 'ri-heart-pulse-line', title: '明星情感', desc: '恋爱、分手、婚变一手掌握', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-tv-2-line', title: '综艺内幕', desc: '录制现场、幕后黑料全曝光', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-film-line', title: '影视爆料', desc: '选角、片酬、剧组真相追踪', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-money-dollar-circle-line', title: '资本暗战', desc: '对赌、收购、股权深层解读', color: 'bg-primary-100/70 text-primary-700' },
  { icon: 'ri-user-star-line', title: '饭圈风云', desc: '应援、打投、粉丝经济内幕', color: 'bg-accent-100/70 text-accent-700' },
  { icon: 'ri-shirt-line', title: '时尚吃瓜', desc: '红毯翻车、代言争夺全记录', color: 'bg-secondary-100/70 text-secondary-700' },
  { icon: 'ri-live-line', title: '直播翻车', desc: '网红翻车事故现场合集', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-global-line', title: '海外八卦', desc: '日韩欧美娱乐圈热门追踪', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          吃瓜群众的专属内容分类，一键直达你关心的领域
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href={`#carousel`}
              className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} flex-shrink-0`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.title}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                  {item.desc}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}